/**
 * API may return `images` as a string (JSON) or array depending on DB/driver.
 * Normalizes to a list of URL strings for forms and galleries.
 */
export function normalizeProductImageUrls(value: unknown): string[] {
  if (value == null) return []
  if (Array.isArray(value)) {
    return value.filter((u): u is string => typeof u === 'string' && u.trim().length > 0)
  }
  if (typeof value === 'string') {
    const t = value.trim()
    if (!t) return []
    try {
      const parsed = JSON.parse(t) as unknown
      if (Array.isArray(parsed)) {
        return parsed.filter((u): u is string => typeof u === 'string' && u.trim().length > 0)
      }
    } catch {
      /* not JSON */
    }
    if (/^https?:\/\//i.test(t)) return [t]
    return []
  }
  return []
}
